module.exports = {"TXTCLI_Available":{"id":"TXTCLI_Available","defaultMessage":"Elérhető"},"TXTCLI_Expires":{"id":"TXTCLI_Expires","defaultMessage":"Lejárat"}}